import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export enum SalesStartMode {
  StartImmediately = 'StartImmediately',
  DateAndTime = 'DateAndTime',
  WhenSalesEndFor = 'WhenSalesEndFor',
}

export enum SalesEndMode {
  DateAndTime = 'DateAndTime',
  StartOfEvent = 'StartOfEvent',
  EndOfEvent = 'EndOfEvent',
}

export class TicketSalesModeComponent extends Component {
  static readonly TYPE_ID: string = '4ac9cb0335c24ffc9c1193348866d6eb';

  constructor(
    public readonly startMode: SalesStartMode,
    public readonly endMode: SalesEndMode,
  ) {
    super();
  }

  get $typeId(): string {
    return TicketSalesModeComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketSalesModeComponent {
    return new TicketSalesModeComponent(
        toEnumFromString(MapUtils.getString(map, 'startMode'), SalesStartMode),
        toEnumFromString(MapUtils.getString(map, 'endMode'), SalesEndMode),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'startMode': fromEnumAsString(this.startMode),
      'endMode': fromEnumAsString(this.endMode),
    };
  }

  clone(): this {
    return new TicketSalesModeComponent(
        this.startMode,
        this.endMode,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.startMode === this.startMode &&
        other.endMode === this.endMode;
  }
}

export class TicketSalesModeComponentBuilder extends DataModelBuilder<TicketSalesModeComponent> {
  build(context: SerializationContext, map: SerializedData): TicketSalesModeComponent {
    return TicketSalesModeComponent.fromMap(context, map);
  }
}
